
export const isLocationInArea = (point, polygonCoords) => {
  const x = point.latitude;
  const y = point.longitude;

  let inside = false;
  for (
    let i = 0, j = polygonCoords.length - 1;
    i < polygonCoords.length;
    j = i++
  ) {
    const xi = polygonCoords[i].latitude;
    const yi = polygonCoords[i].longitude;
    const xj = polygonCoords[j].latitude;
    const yj = polygonCoords[j].longitude;

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) inside = !inside;
  }

  return inside;
};
